import React from "react";
import { Button, Card, Space, Tag, Typography } from "antd";
import { OdReviewIssue } from "../../../services/odReview/odReview.types";
import { OD_REVIEW_ERROR_TYPE_LABELS } from "./labels";
import {
  formatCitedReference,
  formatResourceProvenance,
  isPhotoIssue,
  readResourceProvenance,
} from "./IssueCard.utils";

const { Title, Paragraph, Text } = Typography;

interface IssueCardProps {
  issue: OdReviewIssue;
  onAccept?: () => void;
  onReject?: () => void;
  onResolve?: () => void;
}

const IssueCard: React.FC<IssueCardProps> = ({
  issue,
  onAccept,
  onReject,
  onResolve,
}) => {
  const isPhoto = isPhotoIssue(issue);
  const isManual = issue.status === "PENDING_MANUAL";
  const primaryLabel = isManual
    ? "Resolver a mano"
    : isPhoto
      ? "Marcar para reemplazo"
      : "Aceptar cambio";
  const onPrimary = isManual ? onResolve : onAccept;
  const provenance = readResourceProvenance(issue);
  const citedReference = provenance ? formatCitedReference(provenance) : null;

  return (
    <Card>
      <Space direction="vertical" size="middle" style={{ width: "100%" }}>
        {isManual && <Tag>Manual</Tag>}
        <div>
          <Title level={5} style={{ marginTop: 0 }}>
            Tipo de error
          </Title>
          <Text>{OD_REVIEW_ERROR_TYPE_LABELS[issue.error_type]}</Text>
        </div>
        <div>
          <Title level={5}>Error</Title>
          <Paragraph strong style={{ marginBottom: 4 }}>
            {issue.error_title}
          </Paragraph>
          <Paragraph>{issue.error_description}</Paragraph>
        </div>
        <div>
          <Title level={5}>Evidencia</Title>
          <Paragraph>{issue.evidence}</Paragraph>
          {provenance && (
            <Text type="secondary" style={{ fontSize: 12, display: "block" }}>
              {formatResourceProvenance(provenance)}
            </Text>
          )}
          {citedReference && (
            <Text type="secondary" style={{ fontSize: 12, display: "block" }}>
              {citedReference}
            </Text>
          )}
        </div>
        <div>
          <Title level={5}>Recomendación</Title>
          <Paragraph>{issue.recommended_fix}</Paragraph>
        </div>
        {isPhoto && (
          <div>
            <Title level={5}>Brief de la foto sustituta</Title>
            <Paragraph>
              {issue.replacement_photo_brief ??
                "El modelo no dejó un brief para esta foto."}
            </Paragraph>
            {issue.photo_file_id && (
              <Text type="secondary" style={{ fontSize: 12, display: "block" }}>
                {`Foto evaluada: ${issue.photo_file_id}`}
              </Text>
            )}
            <Text type="secondary" style={{ fontSize: 12, display: "block" }}>
              Esta foto se reemplaza en el editor de la actividad, más abajo. El
              editor de texto no aplica a un error de foto.
            </Text>
          </div>
        )}
        <Space>
          <Button onClick={onReject}>Rechazar cambio</Button>
          <Button type="primary" onClick={onPrimary}>
            {primaryLabel}
          </Button>
        </Space>
      </Space>
    </Card>
  );
};

export default IssueCard;
